// UK coverage areas — regions + every UK county, used by supplier forms & filters
export const UK_REGIONS = ["Nationwide", "South East", "South West", "North East", "North West"];

export const UK_COUNTY_GROUPS = {
  England: [
    "Bedfordshire", "Berkshire", "Bristol", "Buckinghamshire", "Cambridgeshire",
    "Cheshire", "City of London", "Cornwall", "County Durham", "Cumbria",
    "Derbyshire", "Devon", "Dorset", "East Riding of Yorkshire", "East Sussex",
    "Essex", "Gloucestershire", "Greater London", "Greater Manchester", "Hampshire",
    "Herefordshire", "Hertfordshire", "Isle of Wight", "Kent", "Lancashire",
    "Leicestershire", "Lincolnshire", "Merseyside", "Norfolk", "North Yorkshire",
    "Northamptonshire", "Northumberland", "Nottinghamshire", "Oxfordshire", "Rutland",
    "Shropshire", "Somerset", "South Yorkshire", "Staffordshire", "Suffolk",
    "Surrey", "Tyne and Wear", "Warwickshire", "West Midlands", "West Sussex",
    "West Yorkshire", "Wiltshire", "Worcestershire",
  ],
  Scotland: [
    "Aberdeenshire", "Angus", "Argyll and Bute", "Ayrshire", "Clackmannanshire",
    "Dumfries and Galloway", "Dunbartonshire", "Dundee", "East Lothian", "Edinburgh",
    "Fife", "Glasgow", "Highland", "Lanarkshire", "Midlothian",
    "Moray", "Orkney", "Perth and Kinross", "Renfrewshire", "Scottish Borders",
    "Shetland", "Stirlingshire", "West Lothian", "Western Isles",
  ],
  Wales: [
    "Clwyd", "Dyfed", "Gwent", "Gwynedd", "Mid Glamorgan",
    "Powys", "South Glamorgan", "West Glamorgan",
  ],
  "Northern Ireland": [
    "County Antrim", "County Armagh", "County Down",
    "County Fermanagh", "County Londonderry", "County Tyrone",
  ],
};

export const ALL_UK_COUNTIES = Object.values(UK_COUNTY_GROUPS).flat();
export const ALL_UK_AREAS = [...UK_REGIONS, ...ALL_UK_COUNTIES];
